import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'
import RegisterAccountForm from '@/components/forms/register-account-form'
import { AuthSplitLayout } from '@/components/layout/auth-split-layout'

const searchSchema = z.object({
  email: z.email().optional().catch(undefined),
})

export const Route = createFileRoute('/register-account')({
  validateSearch: searchSchema,
  component: RegisterAccountPage,
})

function RegisterAccountPage() {
  const { email } = Route.useSearch()
  const { t } = useTranslation()

  return (
    <AuthSplitLayout>
      <div className="flex-1 flex flex-col justify-center w-full md:flex-none md:mb-6 md:space-y-6">
        <div className="flex flex-col gap-y-3">
          <h1 className="heading-1 text-center">{t('registerAccountPage.title')}</h1>
          <p className="body-1 text-text-secondary text-center">
            {t('registerAccountPage.description')}
          </p>
        </div>
      </div>

      <div className="w-full gap-6 flex flex-col">
        <RegisterAccountForm lockedEmail={email} />
      </div>
    </AuthSplitLayout>
  )
}
